import React, { Component } from 'react'
import { compose, graphql } from 'react-apollo'
import {
  get,
  filter,
  each,
  noop
} from 'lodash'
import { Constants } from '@sukiai/components'
import VideoPlayer from '../IntroTutorial/videoPlayer'
import { getStatusPageComponents, STATUSPAGE_COMPONENT_STATES, getOobeFile } from '../../lib'
import { SET_AGENT_POSITION, SET_AGENT_SIZE } from '../../apollo/actions'
import {
  SUKI,
  HELP_TITLE,
  HELP_DESC1,
  HELP_DESC2,
  VIDEO_TITLE,
  VIDEO_DESC,
  CHAT_TITLE,
  CHAT_DESC,
  HELP,
  VIDEO,
  CHAT,
  STATUS_TITLE
} from './constants'
import {
  Container,
  ActionContainer,
  Title,
  Desc,
  StyledText,
  ContentText,
  StatusIcon,
  HelpIcon,
  PlayButtonIcon,
  HelpChatIcon,
  StatusContainer,
  ContentHolder,
  IconContainer,
  StyledAdditionalText
} from './styled'
import ListPanelWrapper from './ListPanelWrapper'

const { AGENT } = Constants

// TODO: Add to util package
const isProd = window.location.origin.match(/suki\.ai/i)
const HELP_URL = isProd ? 'http://help.suki.ai' : 'http://help.suki-stage.com'

const showWindow = url => {
  // TODO: change to https, once we set that up
  const win = window.open(url, '_blank')
  win.focus()
}

class HelpContainer extends Component {
  state = {
    sukiStatus: STATUSPAGE_COMPONENT_STATES.OPERATIONAL,
    childHoverState: {
      [HELP]: false,
      [VIDEO]: false,
      [CHAT]: false
    },
    shouldVideoPlayerShowAndPlay: false
  }

  componentDidMount = async () => {
    const { setAgentPosition, setAgentSize } = this.props

    setAgentSize(AGENT.SIZE.LARGE)
    setAgentPosition(AGENT.POSITION.MIDDLE_LEFT)

    const statusObj = await getStatusPageComponents()

    // Suki Service
    const Suki = filter(get(statusObj, 'statusComponents'), c => c.name === SUKI)[0]
    const SukiStatus = get(Suki, 'status', 'Operational')
    const currentServiceStatus = STATUSPAGE_COMPONENT_STATES[SukiStatus.toUpperCase()]
    this.setState({ sukiStatus: currentServiceStatus })
  }

  // When the question mark icon is clicked
  handleHelpClicked = () => {
    // Link to help page
    showWindow(HELP_URL)
  }

  // When the chat icon is clicked show intercom
  handleHelpChatClicked = () => {
    window.Intercom('update', {
      hide_default_launcher: false
    })
    window.Intercom('show')
    window.Intercom('onHide', () => {
      window.Intercom('update', {
        hide_default_launcher: true
      })
    })
  }

  // When the play button is clicked
  handlePlayClick = val => {
    this.setState({ shouldVideoPlayerShowAndPlay: val })
  }

  onMouseEnterElem = elemKey => {
    const newChildHoverState = {}
    each(this.state.childHoverState, (val, key) => {
      newChildHoverState[key] = (elemKey === key)
    })
    this.setState({ childHoverState: newChildHoverState })
  }

  onMouseLeaveElem = () => {
    const newChildHoverState = {}
    each(this.state.childHoverState, (val, key) => {
      newChildHoverState[key] = false
    })
    this.setState({ childHoverState: newChildHoverState })
  }

  // Render each subchild(chat, player, help-faq)
  renderSubChildren = (title, icon, callback, childKey, desc, additionalDesc) => {
    return (
      <ActionContainer
        onMouseEnter={() => { this.onMouseEnterElem(childKey) }}
        onMouseLeave={() => { this.onMouseLeaveElem() }}
        ishovered={this.state.childHoverState[childKey] ? 'true' : 'false'}
        onClick={callback}
      >
        <ContentHolder>
          <Title>
            {title}
          </Title>
          <Desc>
            <StyledText>{desc}</StyledText>
            {additionalDesc && <StyledAdditionalText> {additionalDesc}</StyledAdditionalText>}
            <IconContainer>
              {icon}
            </IconContainer>
          </Desc>
        </ContentHolder>
      </ActionContainer>
    )
  }

  // Rendering of all the children of the Help panel
  // status section, help faq, player, help chat
  renderChildren = () => {
    const { sukiStatus } = this.state
    return (
      <Container>
        {this.renderSubChildren(HELP_TITLE, <HelpIcon />, this.handleHelpClicked, HELP, HELP_DESC1, HELP_DESC2)}
        {this.renderSubChildren(VIDEO_TITLE, <PlayButtonIcon />, () => this.handlePlayClick(true), VIDEO, VIDEO_DESC)}
        {this.renderSubChildren(CHAT_TITLE, <HelpChatIcon />, this.handleHelpChatClicked, CHAT, CHAT_DESC)}
        <StatusContainer>
          <Title>
            {STATUS_TITLE}
          </Title>
          <Desc>
            <StatusIcon color={sukiStatus.colors.iconColor} />
            <ContentText color={sukiStatus.colors.textColor}>
              {sukiStatus.label}
            </ContentText>
          </Desc>
        </StatusContainer>
      </Container>
    )
  }

  render () {
    const videoFile = getOobeFile()
    return (
      <div>
        <ListPanelWrapper
          renderChildElems={this.renderChildren}
        />
        <VideoPlayer
          isPlayerVisible={this.state.shouldVideoPlayerShowAndPlay}
          onPlayerClose={() => this.handlePlayClick(false)}
          videoURL={`https://storage.googleapis.com/oobe-videos/${videoFile}`}
          handleClosedButton={noop}
        />
      </div>
    )
  }
}

export default compose(
  graphql(SET_AGENT_POSITION, {
    props: ({ mutate }) => ({
      setAgentPosition: agentPosition => mutate({
        variables: { agentPosition }
      })
    })
  }),
  graphql(SET_AGENT_SIZE, {
    props: ({ mutate }) => ({
      setAgentSize: agentSize => mutate({
        variables: { agentSize }
      })
    })
  })
)(HelpContainer)
